import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DIAGNOSTICS_CONNECTION_STEP, RemoteDiagnosticsStore } from '@store';

import { DiagnosticsOverlayTypeEnum } from '../../../../+installations/installation/installation-overlay.model';

@Component({
  selector: 'app-diagnostics-connection-modal',
  templateUrl: './diagnostics-connection-modal.component.html',
  styleUrls: ['./diagnostics-connection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticsConnectionModalComponent implements OnInit, OnDestroy {
  readonly step = DIAGNOSTICS_CONNECTION_STEP;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  public activeStep: DIAGNOSTICS_CONNECTION_STEP;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { gatewaySerial: string; overlayType?: DiagnosticsOverlayTypeEnum },
    private dialogRef: MatDialogRef<DiagnosticsConnectionModalComponent>,
    private cdr: ChangeDetectorRef,
    private remoteDiagnosticsStore: RemoteDiagnosticsStore
  ) {}

  ngOnInit(): void {
    this.remoteDiagnosticsStore.getActiveConnectionStep$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((step) => {
        this.activeStep = step;
        this.cdr.detectChanges();
      });
  }

  onCancel(step?: DIAGNOSTICS_CONNECTION_STEP): void {
    this.dialogRef.close(step);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
